"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconWrapper = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _designTokens = require("@smartsheet/design-tokens");
var _spacing = require("../../../constants/spacing");
var _getButtonLoadingStyles = require("../styled/getButtonLoadingStyles");
const ursaMargin = {
  xsmall: _designTokens.space.space05,
  small: _designTokens.space.space10,
  medium: _designTokens.space.space20,
  large: _designTokens.space.space30
};
const singleIconMargin = {
  xsmall: `2px`,
  small: `2px`,
  medium: _designTokens.space.space10,
  large: _designTokens.space.space20
};
const insideMargin = {
  xsmall: 1,
  small: 1,
  medium: 3,
  large: 3
};
const iconsOnlyInsideMargin = {
  xsmall: -1,
  small: 1,
  medium: 2,
  large: 2
};
const getIconWrapperMargin = _ref => {
  let {
    size,
    appearance,
    iconLocation,
    hasLeftIcon,
    hasOnlyIcons,
    hasRightIcon
  } = _ref;
  const isTwoIconsOnly = hasLeftIcon && hasRightIcon && hasOnlyIcons;
  const isSingleIcon = hasOnlyIcons && (hasLeftIcon && !hasRightIcon || !hasLeftIcon && hasRightIcon);
  switch (appearance) {
    // For Lodestar buttons.
    case "borderless":
    case "primary":
    case "secondary":
    case "destructive":
    case "secondary-destructive":
    case "share":
      if (isSingleIcon) {
        return `calc(${singleIconMargin[size]} - 1px) var(--sds--button--padding-x-icon--${size}, calc(${singleIconMargin[size]} - 1px))`;
      } else {
        return `0 var(--sds--button--padding-x-icon--${size}, ${(size === "large" ? _spacing.sizes.xSmall : _spacing.sizes.xxSmall) - 1}px)`;
      }
    // For Ursa buttons.
    case "primary-filled":
    case "primary-empty":
    case "secondary-filled":
    case "secondary-outlined":
    case "secondary-empty":
    case "canvas-filled":
    case "canvas-empty":
    case "destructive-filled":
    case "destructive-empty":
      if (isSingleIcon) {
        return `auto var(--sds--button--padding-x-icon--${size}, auto)`;
      } else {
        if (iconLocation === "before") {
          return isTwoIconsOnly && size === "small" ?
          // account for size small outer spacing being different than all other situations
          `0 var(--sds--button--padding-x-icon--${size}, 1px)` : `0 var(--sds--button--padding-x-icon--${size}, ${insideMargin[size]}px) 0 var(--sds--button--padding-x-icon--${size}, calc(${ursaMargin[size]} - 1px))`;
        } else {
          return isTwoIconsOnly && size === "small" ?
          // account for size small outer spacing being different than all other situations
          `0 var(--sds--button--padding-x-icon--${size}, 1px)` : `0 var(--sds--button--padding-x-icon--${size}, calc(${ursaMargin[size]} - 1px)) 0 var(--sds--button--padding-x-icon--${size}, ${insideMargin[size]}px)`;
        }
      }
  }
};
const IconWrapper = (0, _styled.default)("div")`
    align-self: center;
    display: flex;
    flex-shrink: 0;
    line-height: 0;
    font-size: 0;
    user-select: none;
    margin: ${_ref2 => {
  let {
    size,
    appearance,
    iconLocation,
    hasLeftIcon,
    hasOnlyIcons,
    hasRightIcon
  } = _ref2;
  return getIconWrapperMargin({
    size,
    appearance,
    iconLocation,
    hasLeftIcon,
    hasOnlyIcons,
    hasRightIcon
  });
}};

    // inner margin overrides for double icons with no text
    margin-left: ${_ref3 => {
  let {
    hasLeftIcon,
    hasOnlyIcons,
    iconLocation,
    size
  } = _ref3;
  return hasLeftIcon && hasOnlyIcons && iconLocation === "after" ? `${iconsOnlyInsideMargin[size]}px` : null;
}};
    margin-right: ${_ref4 => {
  let {
    hasRightIcon,
    hasOnlyIcons,
    iconLocation,
    size
  } = _ref4;
  return hasRightIcon && hasOnlyIcons && iconLocation === "before" ? `${iconsOnlyInsideMargin[size]}px` : null;
}};

    ${_ref5 => {
  let {
    isLoading
  } = _ref5;
  return (0, _getButtonLoadingStyles.getButtonLoadingStyles)(isLoading);
}}
`;
exports.IconWrapper = IconWrapper;
//# sourceMappingURL=IconWrapper.js.map